import React, {Fragment, useState, useEffect} from 'react'
import * as cardStyles from '../../styles/project-modules/bills/card.module.less'
import SafeLink from '../sfc/safelink'
import slugify from 'slugify'
import Progress from './Progress'
import Person from './Person'
import ReporterComment from './ReporterComment'
import { styled } from '@mui/material/styles';
// import Tooltip, {tooltipClasses} from '@mui/material/Tooltip';

function Card({
  bill,
  link = true,
  className,
  publicationName,
  MARKET_KEY,
  YEAR,
  minimal = false,
  embed=false,
  url_append = ``
}) {
  const { bill_number: number, title, description, sponsors, dead_bill, merged_bill, main_author, main_author_party } = bill
  const [reporterCommentActive, setReporterCommentActive] = useState(false)
  let sponsor = sponsors ? sponsors[0] : {}

  // const LightTooltip = styled(({ className, ...props }) => (
  //   <Tooltip {...props} classes={{ popper: className }} />
  // ))(({ theme }) => ({
  //   [`& .${tooltipClasses.tooltip}`]: {
  //     backgroundColor: theme.palette.common.white,
  //     color: 'rgba(0, 0, 0, 0.87)',
  //     boxShadow: theme.shadows[1],
  //     fontSize: 11,
  //     maxWidth: 500
  //   },
  // }));

  return (
    <li
      className={`${cardStyles.container} ${
        minimal ? cardStyles.minimalContainer : ''
      } ${
        dead_bill || merged_bill ? cardStyles.deadBill : ''
      } ${className}`}
    >
      <div className={cardStyles.headerContainer}>
        <div>
          {link ? (
            <span className={cardStyles.kicker}>
              <SafeLink
                href={`${url_append}/${YEAR}/${slugify(number)}`}
                withinProject={!embed}
                withinEmbed={embed}
              >
              {number}
              </SafeLink>
            </span>
            ) : (<span className={cardStyles.kicker}>{number}</span>)}
            {dead_bill && <span className={`${cardStyles.kicker} ${cardStyles.deadBillIcon}`}>DEAD</span>}
            {merged_bill && <span className={`${cardStyles.kicker} ${cardStyles.deadBillIcon}`}>MERGED</span>}
            {}
        </div>
        <h3 className={cardStyles.title}>{title}</h3>
        <p
          className={cardStyles.description}
          dangerouslySetInnerHTML={{ __html: description }}
        />
            {bill.reporter_comment && <span className={cardStyles.tooltipButton} onClick={(() => setReporterCommentActive(!reporterCommentActive))}>{reporterCommentActive ? "Hide reporter comment" : "Show reporter comment"}</span>}

            {bill.reporter_comment && (
              
              // <ReporterComment
              //   publicationName={publicationName}
              //   comment={bill.reporter_comment}
              //   reporter={bill.reporter_credit}
              // />
              // <LightTooltip
              // placement="top"
              // className={cardStyles.tooltipContainer}
              // enterTouchDelay={0}
              // leaveTouchDelay={20000}
              // title={
              //   <React.Fragment>
              //     <h3 className={cardStyles.tooltipHeading}>Reporter comment</h3>
              //     <p className={cardStyles.tooltipBody}dangerouslySetInnerHTML={{__html: bill.reporter_comment}}/>
              //     <p className={cardStyles.tooltipBody}><strong> {bill.reporter_credit ? ('- ' + bill.reporter_credit) : ''} </strong></p>
              //   </React.Fragment>
              // }
              // >
              // <span className={cardStyles.tooltipButton}>Reporter comment</span>
              // </LightTooltip>
              reporterCommentActive &&  (<div className={cardStyles.reporterCommentInline}>
                   <h3 className={cardStyles.tooltipHeading}>Reporter comment</h3>
                  <p className={cardStyles.tooltipBody}dangerouslySetInnerHTML={{__html: bill.reporter_comment}}/>
                   <p className={cardStyles.tooltipBody}><strong> {bill.reporter_credit ? ('- ' + bill.reporter_credit) : ''} </strong></p>
                 </div>)
              
            )}
    
        {minimal === false && (
          <>
   
            <p className={`${cardStyles.sponsor} ${cardStyles.itemContainer}`}>
              { MARKET_KEY != 'SFC' && MARKET_KEY != 'Houston' && MARKET_KEY != 'SanAntonio' && MARKET_KEY != 'Texcom' ? (
                <span className={cardStyles.itemTitle}>Sponsored by</span>
              ):
              (
                <span className={cardStyles.itemTitle}>Authors</span>
              )}
              
              <Person
                name={
                  sponsor['committee_name']
                    ? `${sponsor['committee_name']} Committee`
                    : `${main_author || sponsor['name']}` 
                }
                // img={sponsor['photo_url'] || null}
                party={ main_author_party || sponsor['party_id'] || null}
                show_more={sponsors.length > 1 ? sponsors : null}
              />
            </p>
            <div className={cardStyles.itemContainer}>
              <span className={cardStyles.itemTitle}>Status</span>
              <Progress bill={bill} minimal={true} MARKET_KEY={MARKET_KEY} />
            </div>
          </>
        )}
      </div>

      {link && (
        <SafeLink
          className={cardStyles.linkContainer}
          href={`${url_append}/${YEAR}/${slugify(number)}`}
          withinProject={!embed}
          withinEmbed={embed}
        >
          Read more
        </SafeLink>
      )}
    </li>
  )
}

export default Card
